export default async ({ store }) => {
  // TODO: Call API for value in Admin Panel to check if car insurance is under maintenance
  // Maybe as an object with the time or the full message under the header
  store.commit('products/setCarAndHomeInsuranceUnderMaintenance', false);
};
